import { render, staticRenderFns } from "./d-book-updates-count.vue?vue&type=template&id=4f6944f0&"
import script from "./d-book-updates-count.vue?vue&type=script&lang=js&"
export * from "./d-book-updates-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports